import { unaryStreamRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const CodeSearchEventTypeSchema = createEnum([
  "result-ready",
  "connection-made",
  "error",
]);
export type CodeSearchEventType = z.infer<typeof CodeSearchEventTypeSchema>;

const CodeSearchEventSchema_ = z.object({
  type: CodeSearchEventTypeSchema,
  outcome: z.string().optional(),
  error: z.string().optional(),
});
export const CodeSearchEventSchema: z.ZodType<CodeSearchEvent> =
  CodeSearchEventSchema_;
export interface CodeSearchEvent
  extends z.infer<typeof CodeSearchEventSchema_> {}

export const watchCodeSearchResult = unaryStreamRpc({
  name: "watchCodeSearchResult",
  input: z.object({
    noticeTopic: z.string(),
    triageThreadId: z
      .string()
      .describe("Thread ID for ownership check and initial result lookup"),
  }),
  output: CodeSearchEventSchema,
});
